import { ReactNode } from "react";
import { cn } from "@/utils/cn";

/** Shared class for native inputs and selects inside modals. */
export const inputClassName =
  "w-full h-9 px-3 rounded-lg border border-gray-200 bg-white text-sm focus:outline-hidden focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400 disabled:bg-gray-50 disabled:text-gray-500";

interface FormFieldProps {
  label: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Label + control + hint/error. */
export function FormField({ label, hint, error, children, className }: FormFieldProps) {
  return (
    <label className={cn("block", className)}>
      <span className="block text-xs font-medium text-gray-600 mb-1">{label}</span>
      {children}
      {error ? <span className="block text-xs text-red-600 mt-1">{error}</span> : hint ? <span className="block text-xs text-gray-400 mt-1">{hint}</span> : null}
    </label>
  );
}
